import './App.css';
import {BrowserRouter,Routes,Route} from 'react-router-dom';
import Register from './pages/Auth/Register';
import Login from './pages/Auth/Login.jsx';
import ForgotPassword from './pages/Auth/ForgotPassword.jsx';
import ProfileSetup from './pages/ProfileSetup/ProfileSetup.jsx';
import SuccessfullRegistered from './pages/Auth/SuccessfullRegistered.jsx';
import OtpLogin from './pages/Auth/OtpLogin.jsx';
import OtpRegister from './pages/Auth/OtpRegister.jsx';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import OtpVerify from './pages/Auth/OtpVerify.jsx';
import RegisterAfterMobile from './pages/Auth/RegisterAfterMobile.jsx';
import ResetPassword from './pages/Auth/ResetPassword.jsx';
import EmailSubmitted from './pages/Auth/EmailSubmitted.jsx';
import SuccessfullPasswordReset from './pages/Auth/SuccessfullPasswordReset.jsx';
import {Parent} from './context/User.jsx';
import HomePage from './pages/HomePage/HomePage.jsx';
import PyschometricTest from './pages/PyschometricTest/PyschometricTest.jsx';
import PyschometricQuestionSwipe from './pages/PyschometricTest/QuestionSwipe.jsx';
import KnowledgeTestSwipe from './pages/KnowledgeTest/QuestionSwipe.jsx'
import GoogleAuthentication from './pages/Auth/GoogleAuth.jsx';
import KnowledgeTest from './pages/KnowledgeTest/KnowledgeTest.jsx';
import PyschometricScore from './pages/PyschometricTest/Score.jsx';
import KnowlegdeTestScore from './pages/KnowledgeTest/Score.jsx';
import ChangePassword from './pages/ChangePassword/index.jsx';
import ViewDetailedReport from './pages/ViewDetailedReport/index.jsx';
import ProtectedRegisterRoute from './components/protectedRegister.jsx';


function App() {
  return (
    <div className="App">
       <BrowserRouter>
       <Routes>
           <Route path="/register" element={<ProtectedRegisterRoute><Register/></ProtectedRegisterRoute>} />
           <Route path="/login" element={<Login/>} />
           <Route path="/otplogin" element={<OtpLogin/>} />
           <Route path="/otpregister" element={<OtpRegister/>} />
           <Route path="/otpverify" element={<OtpVerify/>} />
           <Route path="/forgotpassword" element={<ForgotPassword/>} />
           <Route path="/successfullpasswordreset" element={<SuccessfullPasswordReset/>} />
           <Route path="/successfullregistered" element={<SuccessfullRegistered/>} />
           <Route path="/registerwithmobileverification" element={<RegisterAfterMobile/>} />
           <Route path="/profilesetup" element={<Parent><ProtectedRoute><ProfileSetup/> </ProtectedRoute></Parent>} />
           <Route path="/changepassword" element={<Parent><ProtectedRoute><ChangePassword/> </ProtectedRoute></Parent>} />
           <Route path="/resetpassword" element={<ResetPassword/>} />
           <Route path="/forgotpassword" element={<ForgotPassword/>} />
           <Route path="/emailsubmitted" element={<EmailSubmitted/>} />
           <Route path="/homepage" element={<ProtectedRoute><HomePage/></ProtectedRoute>} />
           <Route path="/viewdetailedreport" element={<ProtectedRoute><ViewDetailedReport/></ProtectedRoute>} />
           <Route path="/pyschometrictest" element={<ProtectedRoute><PyschometricTest/></ProtectedRoute>} />
           <Route path="/knowledgetest/questions/score" element={<ProtectedRoute><KnowlegdeTestScore/></ProtectedRoute>} />
           <Route path="/pyschometrictest/questions/score" element={<ProtectedRoute><PyschometricScore/></ProtectedRoute>} />
           <Route path="/knowledgetest" element={<Parent><ProtectedRoute><KnowledgeTest/></ProtectedRoute></Parent>} />
           <Route path="/pyschometrictest/questions" element={<Parent><ProtectedRoute><PyschometricQuestionSwipe/></ProtectedRoute></Parent>} />
           <Route path="/knowledgetest/questions" element={<Parent><ProtectedRoute><KnowledgeTestSwipe/></ProtectedRoute></Parent>} /> 
           {/* <Route path="/googleauth" element={<GoogleAuthentication/>} /> */}
         </Routes>
       </BrowserRouter>
    </div>
  );
}

export default App;
